import React, {Component} from "react";
import Logo from "../../images/logo.png";
import Coin1 from "../../images/header-kucoin.svg";
import Coin2 from "../../images/header-gateio.svg";
import Coin3 from "../../images/header-pancake.svg";
import { Link } from "react-router-dom";
import ConnectPopUp from "./connectPopUp";

class Header extends Component {
    constructor(props){
        super(props);
        this.state = {
            showConnect : false,
            showModal: false,
        }
    }
    render(){
        return(
            <React.Fragment>
                <header>
                    <div className="main-header-widget">
                        <Link to="/">
                            <img src={Logo} alt="Company Logo" className="logo-image" />
                        </Link>
                        <nav>
                            <h3 className="prim-txt"> Staking    
                                <span className="sec-txt" style={{margin:"0 5%"}}>
                                    <Link to="/assets">
                                        Assets
                                    </Link>
                                </span> |  

                                <span className="sec-txt" style={{margin:"0 5%"}}>
                                    <Link to="/lp">
                                            LP
                                    </Link>
                                </span>
                            </h3>
                            <h4>
                                <span>Arata: </span>
                                <span>$0.28</span>
                            </h4>
                            <div className="header-space-card sec-text small-txt">
                                Contract Address: 0xde3db045c7
                            </div>
                            <div className="header-space-card rounds-flex buy-coin">
                                <p>Buy Arata:</p>
                                <img src={Coin1} />
                                <img src={Coin2} />
                                <img src={Coin3} />
                            </div>
                        </nav>
                        <button onClick={() => this.setState({showConnect : !this.state.showConnect})}>
                                <i className="fas fa-link"></i> Connect Wallet
                        </button>

                        <div className="mobile-toggle">
                            <i onClick={() => this.setState({showModal: !this.state.showModal})} className="fi fi-rr-menu-burger"></i>
                        </div>

                        

                        {/* Mobile Header modal */}

                        { this.state.showModal ?

                            <div className="mobile-modal">
                                <div className="mobile-modal-child">
                                    <i className="fi fi-rr-cross" onClick={() => this.setState({showModal: !this.state.showModal})}></i>
                                    <div className="mobile-comp-info">
                                        <img src={process.env.PUBLIC_URL + "./images/logo.png"} />
                                        <h3>Arata</h3>
                                    </div>

                                    <div className="infos">
                                        <h3>Contract Address: 0xde3db045c7 </h3>
                                        <div className="header-space-card rounds-flex buy-coin" style={{margin:"1rem 0"}}>
                                            <p>Buy Arata:</p>
                                            <img src={Coin1} />
                                            <img src={Coin2} />
                                            <img src={Coin3} />
                                        </div>
                                        <div>
                                            <h3>Staking</h3>
                                            <ul>
                                                <li><Link onClick={() => this.setState({showModal: !this.state.showModal})} to="/assets">Assets</Link></li>
                                                <li><Link onClick={() => this.setState({showModal: !this.state.showModal})} to="/lp">LP</Link></li>
                                            </ul>
                                        </div>
                                        <button style={{margin: "1rem 0"}} onClick={() => this.setState({showConnect : !this.state.showConnect})}>Connect Wallet</button>
                                    </div>
                                </div>
                            </div>

                            :

                            null 

                            }

                        {/* End of Mobile Header modal */}

                        
                        
                    </div>
                </header>

                {
                    this.state.showConnect ?
                    
                    <div className="modal-widget">
                        <div className="modal-child">
                            <i className="fi fi-rr-cross" onClick={() => this.setState({showConnect: !this.state.showConnect})}></i>
                            <h3>Connect Wallet</h3>
                            <button>MetaMask</button>
                        </div>
                    </div>

                    : null
                }
            </React.Fragment>
        )
    }
}

export default Header;